export const DEFAULT = 'default';